import { get, post, put } from './apiClient';
import type { AuthTokens, InvitationPreview, LoginResult, TenantSummary, UserProfile } from '../types/auth';

export const authApi = {
  login: (email: string, password: string) =>
    post<LoginResult>('/auth/login', { email, password }),

  selectTenant: (selectionToken: string, tenantId: string) =>
    post<AuthTokens>('/auth/select-tenant', { selectionToken, tenantId }),

  switchTenant: (tenantId: string) =>
    post<AuthTokens>('/auth/switch-tenant', { tenantId }),

  /** 29.16: reissues tokens carrying only `role`, in `tenantId` (the current tenant or another of the person's). */
  switchRole: (tenantId: string, role: string) =>
    post<AuthTokens>('/auth/switch-role', { tenantId, role }),

  myTenants: () => get<TenantSummary[]>('/auth/tenants'),

  refresh: (refreshToken: string) =>
    post<AuthTokens>('/auth/refresh', { refreshToken }),

  logout: (refreshToken: string) =>
    post<void>('/auth/logout', { refreshToken }),

  forgotPassword: (email: string) =>
    post<void>('/auth/forgot-password', { email }),

  resetPassword: (email: string, token: string, newPassword: string) =>
    post<void>('/auth/reset-password', { email, token, newPassword }),

  previewInvitation: (token: string) =>
    post<InvitationPreview>('/auth/preview-invitation', { token }),

  acceptInvitation: (token: string, password: string | null, firstName: string, lastName: string) =>
    post<AuthTokens>('/auth/accept-invitation', { token, password, firstName, lastName }),

  changePassword: (currentPassword: string, newPassword: string) =>
    put<void>('/auth/change-password', { currentPassword, newPassword }),

  me: () => get<UserProfile>('/auth/me'),

  updateMe: (profile: Omit<UserProfile, 'id' | 'email' | 'mustCompleteProfile' | 'roles'>) =>
    put<void>('/auth/me', profile),
};
